
export const EditPractice = ({ section, onUpdated, style = {} }) => {

  return (
    <div style={{ display: "flex", flexDirection: "column", ...style }}>
      Edit Practice
    </div>
  )
}

export default EditPractice;
